export const extWidgetRecommendationConfig = [
  { maxWidth: 480, isMobile: true, cardsPerRow: 4 },
  { maxWidth: 620, isMobile: false, cardsPerRow: 3 },
  { maxWidth: 760, isMobile: false, cardsPerRow: 4 },
  { maxWidth: Infinity, isMobile: false, cardsPerRow: 5 },
];
